module.exports = __webpack_public_path__ + "media/site_templates/www.plumbingservices.company/images/our_services_1-bf29c03318d424987128f3821f793917.jpg";